import type { CodemodOrder } from '@design-system/migration-utils';

import {
  migrateCodesnippetCopyActionMotion,
  migrateCodesnippetCopyActionCodemod,
} from './codemods/migrate-codesnippet-copy-action.js';

export const codemodOrder: CodemodOrder = [
  {
    description:
      'migrate deprecated CodeSnippet allowCopy, showCopyAction and onCopy props to CodeSnippet.ActionsMenu with CodeSnippet.Copy',
    motion: migrateCodesnippetCopyActionMotion,
    codemod: migrateCodesnippetCopyActionCodemod,
  },
];
